module.exports = __webpack_public_path__ + "static/media/girl-2nd.aaad2adf.png";